import React from "react";
import { PencilSimple } from "@phosphor-icons/react";
import PrimaryButton from "components/common/buttons/PrimaryButton";
import { useLocale } from "lib/hooks/useLocale";

interface ContinueAsProps {
  firstName: string;
  selectedEmail: string;
  onContinue: () => void;
  onChangeEmail: () => void;
  isLoading?: boolean;
}

const ContinueAs: React.FC<ContinueAsProps> = ({
  firstName,
  selectedEmail,
  onContinue,
  onChangeEmail,
  isLoading = false,
}) => {
  const { t } = useLocale();
  const avatarLetter = selectedEmail.charAt(0).toUpperCase();

  return (
    <div className="flex w-full flex-col">
      {/* Header */}
      <div className="flex flex-col items-start justify-end px-6 pb-3 pt-6">
        {firstName ? (
          <div className="flex w-full gap-1 items-start">
            <span className="shrink-0 text-text-md-medium text-zinc-500">
              {t("shopify_login.continue_as")}
            </span>
            <div className="flex min-w-0 flex-1 items-center pr-6">
              <span className="min-w-0 flex-1 truncate text-text-md-semibold text-zinc-800">
                {firstName},
              </span>
            </div>
          </div>
        ) : (
          <span className="text-text-md-semibold text-zinc-800">
            {t("shopify_login.hey_there")}
          </span>
        )}
      </div>

      {/* Body */}
      <div className="flex flex-col gap-3 bg-gray-lightest p-4">
        <div className="flex flex-col gap-1">
          <div className="flex items-center px-2">
            <p className="text-text-xs-medium text-zinc-500">
              {t("shopify_login.access_as")}
            </p>
          </div>

          {/* Email card */}
          <div className="rounded-xl border border-[rgba(9,9,11,0.06)] bg-white px-3 py-2">
            <div className="flex h-[38px] items-center gap-2 py-1">
              {/* Avatar */}
              <div className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-lighter">
                <span className="text-base font-semibold uppercase tracking-[0.04em] text-zinc-800">
                  {avatarLetter}
                </span>
              </div>

              {/* Email */}
              <div className="flex min-w-0 flex-1 flex-col items-center justify-center">
                <p className="w-full text-text-sm-medium text-zinc-800 truncate">
                  {selectedEmail}
                </p>
              </div>

              {/* Change button */}
              <button
                onClick={onChangeEmail}
                className="flex shrink-0 items-center gap-1 px-1.5 py-1">
                <PencilSimple className="h-4 w-4 text-black opacity-60" weight="regular" />
                <span className="text-text-xs-semibold text-black opacity-60">
                  {t("change")}
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Continue CTA */}
        <PrimaryButton
          buttonText={t("continue")}
          height="h-11"
          borderRadius="rounded-xl"
          isLoading={isLoading}
          isDisabled={isLoading}
          onClick={onContinue}
          className="!bg-[#27272a] !text-white"
        />
      </div>
    </div>
  );
};

export default ContinueAs;
